import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./en.js";
import { ru } from "./ru.js";

void i18n.use(initReactI18next).init({
  resources: {
    ru: { translation: ru },
    en: { translation: en },
  },
  lng: "ru",
  fallbackLng: false,
  supportedLngs: ["ru", "en"],
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

export { i18n };
